import { useState, useEffect, useRef } from "react"

export const useDelayedInput = <T extends string | number>(
    initialValue: T,
    delay: number,
    onStopTyping: (value: T) => void
) => {
    const [value, setValue] = useState<T>(() => initialValue)
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
    const callbackRef = useRef(onStopTyping)
    const isFirstRun = useRef(true)

    // обновляем ссылку на callback
    useEffect(() => {
        callbackRef.current = onStopTyping
    }, [onStopTyping])

    useEffect(() => {
        // Пропускаем самое первое выполнение эффекта
        if (isFirstRun.current) {
            isFirstRun.current = false
            return
        }

        if (timerRef.current) clearTimeout(timerRef.current)

        timerRef.current = setTimeout(() => {
            callbackRef.current(value)
        }, delay)

        return () => {
            if (timerRef.current) clearTimeout(timerRef.current)
        }
    }, [value, delay])

    return { value, setValue }
}
